import { useQuery } from "./useQuery";

const queryBlackList = ["token", "canGoBack"];

const haveFilters = (): boolean => {
	// eslint-disable-next-line react-hooks/rules-of-hooks
	const query = useQuery();
	let haveFilter = false;
	query.forEach((value, key) => {
		if (queryBlackList.includes(key)) return false;
		haveFilter = true;
	});
	return haveFilter;
};

export default haveFilters;
